export enum LabelPreferenceEnum {
    PrintLabels = 'Print Labels',
    PrePrintedLabels = 'Use Pre-printed Labels'
}

export enum BulkOrderTemplateSelection {
    CreatePackageAndOrder = 'Create new package & order',
    AddOrder = 'Add orders to existing package'
}